import HookGetVariablesLanguage from "../../../../utils/hookGetVariablesLanguage";

export const LangContext = () => {
  const variable_2 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_2",
  });
  const variable_6 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_6",
  });
  const variable_7 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_7",
  });
  const variable_8 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_8",
  });
  const variable_9 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_9",
  });
  const variable_10 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_10",
  });
  const variable_11 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_11",
  });
  const variable_12 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_12",
  });
  const variable_13 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_13",
  });
  const variable_18 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_18",
  });
  const variable_19 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_19",
  });
  const variable_21 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_21",
  });
  const variable_22 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_22",
  });
  const variable_23 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_23",
  });
  const variable_24 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_24",
  });
  const variable_25 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_25",
  });
  const variable_26 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_26",
  });
  const variable_27 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_27",
  });
  const variable_28 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_28",
  });
  const variable_29 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variables_29",
  });
  const variable_30 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variables_30",
  });
  // видео
  const variable_41 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_41",
  });
  const variable_47 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_47",
  });
  const variable_53 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_53",
  });
  const variable_58 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_58",
  });
  const variable_59 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_59",
  });
  const variable_56 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_56",
  });
  const variable_55 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_56",
  });
  const variable_60 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_60",
  });
  const variable_61 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_61",
  });
  const variable_62 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_62",
  });
  const variable_63 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_63",
  });
  const variable_64 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_64",
  });
  const variable_65 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_65",
  });
  const variable_66 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_66",
  });
  const variable_67 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_67",
  });
  const variable_68 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_68",
  });
  const variable_69 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_69",
  });
  const variable_70 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_70",
  });
  const variable_71 = HookGetVariablesLanguage({
    keyPage: "landing",
    keyVariable: "variable_71",
  });
  return {
    variable_21,
    variable_22,
    variable_23,
    variable_24,
    variable_25,
    variable_26,
    variable_27,
    variable_7,
    variable_18,
    variable_2,
    variable_8,
    variable_9,
    variable_53,
    variable_58,
    variable_59,
    variable_56,
    variable_55,
    variable_47,
    variable_60,
    variable_61,
    variable_62,
    variable_63,
    variable_19,
    variable_6,
    variable_64,
    variable_41,
    variable_10,
    variable_11,
    variable_12,
    variable_13,
    variable_65,
    variable_66,
    variable_67,
    variable_68,
    variable_69,
    variable_70,
    variable_71,
    variable_29,
    variable_30,
    variable_28,
  };
};
